import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

import { ModalType, ScreenType } from '@/src/modules/CampaignsModule/interfaces/Campaigns';

export const atomToggleEditCreateCampaignModal = atom<boolean>(false);
atomToggleEditCreateCampaignModal.debugLabel = 'atomToggleEditCreateCampaignModal';

export const atomModalTypeProcess = atomWithReset<ModalType>(ModalType.CREATE);
atomModalTypeProcess.debugLabel = 'atomModalTypeProcess';

//TODO: remove this atom before reactor campaigns
export const atomScreenTypeProcess = atomWithReset<ScreenType>(ScreenType.MAIN);
atomScreenTypeProcess.debugLabel = 'atomScreenTypeProcess';

export const atomToggleDeleteModal = atom<boolean>(false);
atomToggleDeleteModal.debugLabel = 'atomToggleDeleteModal';

export const atomToggleEditActionsModal = atom<boolean>(false);
atomToggleEditActionsModal.debugLabel = 'atomToggleEditActionsModal';

export const atomToggleDuplicateActionsModal = atom<boolean>(false);
atomToggleDuplicateActionsModal.debugLabel = 'atomToggleDuplicateActionsModal';

export const atomToggleMoveActionsModal = atom<boolean>(false);
atomToggleMoveActionsModal.debugLabel = 'atomToggleMoveActionsModal';

export const atomToggleDeleteActionsModal = atom<boolean>(false);
atomToggleDeleteModal.debugLabel = 'atomToggleDeleteModal';

//TODO: remove this atom before reactor campaigns
export const atomToggleDuplicateCampaignModal = atom<boolean>(false);
atomToggleDuplicateCampaignModal.debugLabel = 'atomToggleDuplicateCampaignModal';

export const atomToggleEditCreateRecurrentModal = atom<boolean>(false);
atomToggleEditCreateRecurrentModal.debugLabel = 'atomToggleEditCreateRecurrentModal';

export const atomToggleDeleteRecurrentModal = atom<boolean>(false);
atomToggleDeleteRecurrentModal.debugLabel = 'atomToggleDeleteRecurrentModal';

export const atomToggleDuplicateRecurrentModal = atom<boolean>(false);
atomToggleDuplicateRecurrentModal.debugLabel = 'atomToggleDuplicateRecurrentModal';

export const atomCampaignValidation = atom<boolean>(false);
atomCampaignValidation.debugLabel = 'atomCampaignValidation';
